function _getBaseNumber(num: number): number {
  return Math.floor(num / 1000);
}

// Returns numbers formatted with decimals to the tenth decimal place with a k suffix;
function _getHundredthsDeciString(num: number): string {
  if (Math.floor((num % 1000) / 100) === 0) return 'k';

  return '.' + Math.floor((num % 1000) / 100) + 'k';
}

export function formatCounterValue(num: number): string {
  if (!num || num < 0) return '0';

  // Remove decimals, if any
  let intNum = parseInt(num.toString());
  if (intNum >= 100000) {
    return `${_getBaseNumber(intNum).toLocaleString()}k`;
  } else if (intNum >= 1000) {
    const base = _getBaseNumber(intNum);
    return `${base.toLocaleString()}${_getHundredthsDeciString(intNum)}`;
  } else {
    return num.toLocaleString();
  }
}

export function handleOverride(overrideNum: number, dataNum: number) {
  if (overrideNum && overrideNum >= 0) {
    return overrideNum;
  }

  return dataNum;
}

export const parseCookieOverrides = (cookieValue: string | undefined) => {
  if (cookieValue && parseInt(cookieValue) >= 0) {
    return parseInt(cookieValue);
  }

  return -1;
};
